@if (returnLine(); as line) {
  <div class="receipt-return-info">
    <div class="text-bold font-lg mb-2"
         [translate]="'receipt.returnPackaging.title'">
      Return information
    </div>

    @if (instructions()) {
      <div class="font-md receipt-return-info__instructions wysiwyg"
           [innerHTML]="instructions()">
      </div>
    }

    <div class="font-md mt-3">
      <span [translate]="'receipt.returnPackaging.chosenTime'"></span>:&nbsp;<span class="text-bold">
        <span class="first-letter-capitalize d-inline-block">
          {{ line.returnPackaging.scheduledDate | i18nDate: 'dddd D MMM' }}
        </span>
        {{ line.returnPackaging.scheduledTime }}
      </span>
    </div>
  </div>
}
